export const version = "solidity/5.6.0";
//# sourceMappingURL=_version.js.map